<template>
  <v-dialog v-model="isOpen" max-width="810">
    <v-card v-if="isOpen" class="lesson-create-dialog py-8">
      <div class="create-title create-title__container text-center title-container">
        <h2 class="lesson-create-dialog">
          {{ $t(currentStep === 1 ?
          'lessonDialogTitle' : 'filesToBeUsed') }}
        </h2>
        <p class="ma-0 ps-2" v-if="currentStep === 2">{{ $t('optional') }}</p>
      </div>
      <v-stepper class="stepper" v-model="currentStep">
        <v-stepper-items>
          <v-stepper-content step="1">
            <!-- eslint-disable-next-line max-len -->
            <lesson-create-form
              class="py-0 pb-4 px-8 px-sm-0"
              @created="createdLesson"
              :prefill="prefill"
            ></lesson-create-form>
          </v-stepper-content>

          <v-stepper-content step="2" class="py-0 pb-8">
            <!-- eslint-disable-next-line max-len -->
            <media-upload :lesson-id="lessonId" @close="close" :media="media" :windows="windows"></media-upload>
            <!-- eslint-disable-next-line max-len -->
            <v-btn color="primary" class="createLessonButton" large depressed rounded block @click="emitDone">{{ $t('done') }}</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
      <v-btn outlined small fab class="v-dialog__close" @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import clone from 'lodash/clone';
import LessonCreateForm from '@/components/forms/LessonCreateForm.vue';
import MediaUpload from '@/components/MediaUpload.vue';

export default {
  props: ['lessons'],
  components: {
    LessonCreateForm,
    MediaUpload,
  },
  data() {
    return {
      isOpen: false,
      lessonId: '',
      currentStep: 1,
      prefill: null,
      media: {
        files: [],
        links: [],
      },
      windows: [
        { type: 'stream', participant: '' },
        { type: 'keynote', page: 1, link: '' },
      ],
    };
  },
  watch: {
    lessons(less) {
      setTimeout(() => {
        const lesson = less.find(n => n.id === this.lessonId);
        if (lesson) {
          this.media = clone(lesson.media);
          this.windows = clone(lesson.windows);
        }
      }, 1000);
    },
    isOpen(val) {
      if (val) this.reset();
    },
  },
  methods: {
    reset() {
      this.lessonId = '';
      this.currentStep = 1;
      this.media = clone({
        files: [],
        links: [],
      });
      this.windows = clone([
        { type: 'stream', participant: '', mode: 'even' },
        {
          type: 'keynote',
          page: 1,
          link: '',
          mode: 'even',
        },
      ]);
    },
    createdLesson(id) {
      this.lessonId = id;
      setTimeout(() => {
        this.currentStep = 2;
      }, 500);
    },
    open() {
      this.reset();
      this.prefill = null;
      this.isOpen = true;
    },
    openAndPrefill(formData) {
      this.reset();
      this.isOpen = true;
      this.prefill = formData;
    },
    emitDone() {
      const lesson = this.lessons.find(n => n.id === this.lessonId);
      if (!Object.keys(lesson.viewers).length) {
        this.$emit('show-link', this.lessonId);
      } else {
        this.close();
      }
    },
    close() {
      this.isOpen = false;
    },
  },
};
</script>

<style lang="scss">
#app {
  .title-container {
    display: flex !important;
    align-items: center;
  }
  .create-title,
  .v-stepper {
    max-width: 580px;
    margin: 0 auto;
    box-shadow: none;
    text-align: center;
    &__header {
      box-shadow: none;
    }
    &__wrapper {
      padding-top: 5px;
    }
    &__step {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
  .create-title-container {
    display: flex;
  }
  .createLessonButton{
  max-width: 300px !important;
  min-width: 230px !important;
  margin: 0 auto;
}

  .lesson-create-dialog {
    .v-form {
      max-width: 580px;
      margin: 0 auto;
      padding-top: 15vh;

      h2 {
        text-align: center;
        max-width: 580px;
      }
    }

    p {
      max-width: 530px;
      margin: 0 auto;
      text-align: center;
      font-size: 16px;
    }

    .v-form {
      padding-top: 0vh;
    }
    .file-upload {
      min-width: 100%;
    }
    .files-upload {
      width: 100%;
    }
    .file {
      padding: 5px;
      width: 50%;
      min-width: 50%;
      &__box {
        width: 100%;
      }
    }
  }

  .lesson-resource-dialog {
    box-shadow: none !important;
    padding-bottom: 10px !important;
  }
}

@media only screen and (max-width: 968px) {
  #app {
    .v-dialog__close {
      right: 26px !important;
      top: 28px !important;
    }
    .create-title {
      padding-top: 50px;
      margin-right: 0px !important;
      text-align: center;
      margin-left: 0px !important;
    }
    .create-about {
      padding-right: 32px !important;
      padding-left: 32px !important;
      padding-bottom: 32px !important;
    }
  }
}
.tag-input span.v-chip::before {
  content: 'label';
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
}
.tag-input span.chip {
  background-color: #d0e6fb !important;
  color: #0091ff;
  font-size: 1em;
}

.tag-input span.v-chip {
  background-color: #d0e6fb !important;
  color: #0091ff;
  font-size: 1em;
  padding-left: 7px;
}
.v-chip.v-size--default {
  border-radius: 6px !important;
}

.title-container {
  justify-content: center !important;
  flex-direction: column;
}
</style>
